import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

function useUnarchiveIncompleteInvestment() {
  return api.incompleteInvestment.unarchive.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Subscription unarchived successfully.',
    }),
  );
}

export default useUnarchiveIncompleteInvestment;
